import React from 'react'
import { paneModes } from '@constants/orderWizard'
import { useWizardMaster } from '../../../../Contexts/WizardMasterContext'
import { AllocatedPocket } from './AllocatedPocket'
import { EmptyPocket } from './EmptyPocket'

export const PocketAllocation = ({ container, index, volumes, maxVolumes }) => {
  const { paneMode } = useWizardMaster()
  if (container && container.targets) {
    const isError = container.targets.some((target) => target.is_error)
    return (
      <AllocatedPocket
        editable={paneMode === paneModes.PRODUCTSELECT}
        index={index}
        container={container}
        isError={isError}
      />
    )
  }
  return <EmptyPocket index={index} volumes={volumes} maxVolumes={maxVolumes} />
}
